import "./ShippingOrderTransport.scss"
import iconStatusSuccess from "assets/img/icon-status-success.svg"

import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import cn from "classnames"

import Spoiler from "components/Spoiler/Spoiler"
import ShippingOrderTransportModel from "models/ShippingOrderTransport"
import { IHasTransportSegmentLoadedAssetsParams, ShippingOrderType } from "models/ShippingOrder"
import ShippingOrderTransportSegment from "./ShippingOrderTransportSegment"
import Text from "components/Text/Text"
import { Flex } from "components/Flex"

interface IShippingOrderTransportProps {
    transport: ShippingOrderTransportModel
    sequence: number
    shippingOrderType: ShippingOrderType
    hasTransportSegmentLoadedAssets(params: IHasTransportSegmentLoadedAssetsParams): boolean
}

const ShippingOrderTransport: FC<IShippingOrderTransportProps> = ({
    transport,
    sequence,
    shippingOrderType,
    hasTransportSegmentLoadedAssets,
}) => {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState(false)

    function renderTransport(toggle: () => void) {
        return (
            <Flex alignItems="center" justifyContent="space-between" gap="0.8rem">
                <button
                    className={cn("shipping-order-transport py-1-5 pr-1 pl-4", { "shipping-order-transport--expanded": expanded })}
                    onClick={toggle}>
                    <Text>{`${t('transport.transportSequenceX', { sequence })}${transport.description ? ` — ${transport.description}` : ''}`}</Text>
                </button>
                {transport.areAllSegmentsComplete &&
                    <img src={iconStatusSuccess} alt="" />
                }
            </Flex>
        )
    }

    return (
        <Spoiler
            id={transport.id}
            expanded={expanded}
            onToggle={setExpanded}
            toggleEl={(_, toggle) => renderTransport(toggle)}>
            <div className="ml-4 mb-1-5">
                {transport.segments.map(segment => (
                    <div key={segment.id} className="border-grey-100-between">
                        <ShippingOrderTransportSegment
                            segment={segment}
                            noItems={segment.isCompleted && !hasTransportSegmentLoadedAssets({
                                transportId: transport.id,
                                departureLocationId: segment.departureLocationId,
                                arrivalLocationId: segment.arrivalLocationId,
                            })}
                            shippingOrderType={shippingOrderType}
                        />
                    </div>
                ))}
            </div>
        </Spoiler>
    )
}

export default ShippingOrderTransport
